// extracted by mini-css-extract-plugin
module.exports = {"prev":"pagination_prev__2MJ12","current":"pagination_current__3u4IG","next":"pagination_next__1qls0"};